export default {
  institutions: [],
  institutionsMeta: {},
  groups: [],
  groupEmployeeSelected: [],
  currentPos: 0
}



// WEBPACK FOOTER //
// ./src/store/modules/institution/state.js